import { useSyncExternalStore } from "react";

export default function useMediaQuery(query) {
  const subscribe = (onStoreChange) => {
    if (typeof window === "undefined") return () => {};
    const mql = window.matchMedia(query);
    const handler = () => onStoreChange();

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }
    // Safari < 14 fallback
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  };

  const getSnapshot = () =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false;

  const getServerSnapshot = () => false; // SSR-safe

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
